<div class="container email-container">
  <div class="row">
    <div class="col-sm-12">
      <h4>
        Your email has not been verified yet!
        <button class="btn-link text-uppercase float-end close" (click)="closeWindow()">&times;</button>
      </h4>
      <p [hidden]="sentVerification">
        Please click "Send Verification Code" to your email address to verify your email first. Please also check your
        <b>Junk/Spam</b> folder in case the email is not in your Inbox.
      </p>
      <form
        *ngIf="confirmEmailFG"
        class="form user-form p-v"
        #form="ngForm"
        [formGroup]="confirmEmailFG"
        (ngSubmit)="confirmEmail(form)"
        novalidate
      >
        <div class="row no-gutters w-100">
          <div class="col-12 col-md-12">
            <div class="input-group row no-gutters">
              <input formControlName="email" type="text" class="input col-sm-5 col-12" placeholder="Email" disabled="true" />
              <button [loading]="sendingCodeInProgress" type="submit" class="col-sm-7 col-md-6 col-12">Send Verification Code</button>
            </div>
            <div [hidden]="confirmEmailFG.controls['email'].valid || !form.submitted" class="alert alert-danger">
              <span [hidden]="!confirmEmailFG.controls.email.errors?.required">Email is required</span>
              <span [hidden]="!confirmEmailFG.controls.email.errors?.email">Email is invalid</span>
            </div>
          </div>
        </div>
      </form>
      <div class="row">
        <div [slide]="sentVerification">
          We have sent you a verfication code to <strong>{{ submittedEmail }}</strong
          >.
          <span class="text-muted">
            If you didn't receive a code via email, please re-check and enter the correct email and click "Send Verfication Code" again.
          </span>
        </div>
        <br />
      </div>
      <form
        *ngIf="verifySignupFG && sentVerification"
        #vform="ngForm"
        [formGroup]="verifySignupFG"
        (ngSubmit)="onVerifySignup(vform)"
        class="form create-account"
        novalidate
      >
        <div class="row">
          <div class="col-12 col-md-8 offset-md-2">
            <div class="input-group">
              <input
                formControlName="verificationCode"
                type="text"
                class="form-control col-sm-4 col-12"
                placeholder="Enter Verification Code"
                tabindex="2"
              />
              <button [loading]="verifyingCodeInProgress" type="submit" class="col-sm-8 col-md-6 col-12">Verify</button>
            </div>
            <div class="form-errors alert alert-danger" [hidden]="!verifySignupErrors || !verifySignupErrors.length">
              <ul>
                <li class="text-left" *ngFor="let error of verifySignupErrors">
                  {{ error }}
                </li>
              </ul>
            </div>
            <div [hidden]="verifySignupFG.controls['verificationCode'].valid || !vform.submitted" class="alert alert-danger">
              <span [hidden]="!verifySignupFG.controls.verificationCode.errors?.required">Enter the Verification Code</span>
            </div>
            <div [hidden]="!verifySuccessMsg" class="alert alert-success" role="alert">Your Email is Confirmed.</div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
